import { ROUTE_NAME } from '@constants';

const useInformation = {
  path: '/use-information',
  redirect: '/use-information/user-guide',
  meta: {
    // isDesktop: false,
    breadcrumb: true,
    breadcrumbName: '이용안내',
    navMenu: true,
    description: '고객 여러분을 위해 보다 나은 서비스를 제공하겠습니다.',
  },
  children: [
    {
      name: ROUTE_NAME.UserGuide,
      path: 'user-guide',
      component: () => import('@views/use-information/UserGuide.vue'),
      meta: {
        breadcrumb: true,
        breadcrumbName: '이용안내',
      },
    },
    // {
    //   name: ROUTE_NAME.FeeInfo,
    //   path: 'fee-info',
    //   component: () => import('@views/use-information/FeeInfo.vue'),
    //   meta: {
    //     breadcrumb: true,
    //     breadcrumbName: '요금안내',
    //   },
    // },
  ],
};
export default useInformation;
